import { TestResolver } from "../../models";
import { Log } from "../log.helpers";
import { getSiblingValueTime } from "./custom-yup-validation-helpers";

export const notBiggerTimeThanSiblingIfSiblingsNumValuesSame: TestResolver = ({
  value,
  context,
  errorMessage,
  validationAdditional,
}) => {
  const siblingNum1Name = validationAdditional.num1 ?? "";
  const siblingNum2Name = validationAdditional.num2 ?? "";
  const siblingFieldName = validationAdditional.siblingName;

  if (
    siblingNum1Name &&
    siblingNum2Name &&
    context.parent[siblingNum1Name] !== context.parent[siblingNum2Name]
  ) {
    return true;
  }

  if (!value) {
    return true;
  }

  const siblingValueTime = getSiblingValueTime({
    siblingFieldName,
    context,
    value: value as string,
  });

  if (!siblingValueTime) {
    return false;
  }

  if (!((siblingFieldName as string) in context.parent)) {
    Log.warn(`Missed sibling field for ${context.path} bypass validation`);
    return true;
  }

  const { siblingTime, valueTime } = siblingValueTime;

  if (valueTime.isBefore(siblingTime)) {
    return true;
  }

  return context.createError({ message: errorMessage });
};
